// ── Minimal markdown parser ──────────────────────────────────────────────────
// Escapes HTML first to prevent XSS, then applies inline and block formatting.

export function escapeHtml(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
}

function applyInline(s) {
    return escapeHtml(s)
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/`(.+?)`/g, '<code class="bg-light px-1 rounded border">$1</code>')
}

export function parseMarkdown(text) {
    const lines = text.split('\n')
    const html = []
    let i = 0

    while (i < lines.length) {
        const line = lines[i]

        // Fenced code block
        if (line.startsWith('```')) {
            const codeLines = []
            i++
            while (i < lines.length && !lines[i].startsWith('```')) {
                codeLines.push(escapeHtml(lines[i]))
                i++
            }
            html.push(`<pre class="bg-dark text-light p-2 rounded small mt-1 mb-1" style="white-space:pre-wrap"><code>${codeLines.join('\n')}</code></pre>`)
            i++ // skip closing ```
            continue
        }

        // Unordered list
        if (/^[-*] /.test(line)) {
            const items = []
            while (i < lines.length && /^[-*] /.test(lines[i])) {
                items.push(`<li>${applyInline(lines[i].replace(/^[-*] /, ''))}</li>`)
                i++
            }
            html.push(`<ul class="mb-1 mt-1">${items.join('')}</ul>`)
            continue
        }

        // Ordered list
        if (/^\d+\. /.test(line)) {
            const items = []
            while (i < lines.length && /^\d+\. /.test(lines[i])) {
                items.push(`<li>${applyInline(lines[i].replace(/^\d+\. /, ''))}</li>`)
                i++
            }
            html.push(`<ol class="mb-1 mt-1">${items.join('')}</ol>`)
            continue
        }

        // Empty line → spacing
        if (line.trim() === '') {
            html.push('<div style="height:8px"></div>')
            i++
            continue
        }

        // Regular line
        html.push(`<span>${applyInline(line)}</span><br>`)
        i++
    }

    return html.join('')
}
